export const Path = ["type", "description", "proof_type", "is_active"]

export const Heading = (t) => [
    { title: t("Type"), field: "type" },
    { title: t("Description"), field: "description" },
    { title: t("Proof Type"), field: "proof_type" },
    { title: t("Status"), field: "is_active", },
    { title: "", field: "icon" },
]

export const Type = [
    { type: ["text"], name: "type" },
    { type: ["long_text"], name: "description" },
    { type: ["text"], name: "proof_type" },
    { type: ["status"], name: "is_active" },
    { type: ["more"], icon: "icon" },
]

export const defaultAddState = {
    formType: "add",
    id: "",
    type: "",
    description: "",
    proof_type: "",
    is_active: true,
    is_delete: false,
    error: {
        type: "",
        proof_type: "",
    }
}

export const defaultFilterData = { is_active: [true] }